<div class="student-comments-container">
  <!-- Header with Add Button -->
  <div class="flex justify-between items-center mb-4">
    <h3 class="text-lg font-semibold">Comentarios sobre el alumno</h3>
    <button
      (click)="openAddModal()"
      class="px-4 py-2 bg-primary text-white rounded hover:bg-red-700 transition"
    >
      + Añadir Comentario
    </button>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="text-center py-8">
    <p class="text-gray-500">Cargando comentarios...</p>
  </div>

  <!-- Empty State -->
  <div *ngIf="!isLoading && comments.length === 0" class="text-center py-8 bg-gray-50 rounded-lg">
    <p class="text-gray-500 mb-4">No hay comentarios sobre este alumno</p>
    <button
      (click)="openAddModal()"
      class="px-4 py-2 bg-primary text-white rounded hover:bg-red-700 transition"
    >
      Añadir primer comentario
    </button>
  </div>

  <!-- Comments List -->
  <div *ngIf="!isLoading && comments.length > 0" class="space-y-4">
    <div
      *ngFor="let comment of comments"
      class="border rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition"
    >
      <!-- Comment Header -->
      <div class="flex justify-between items-start mb-2">
        <div class="flex items-center gap-2 flex-wrap">
          <span
            class="px-2 py-1 text-xs font-medium rounded"
            [ngClass]="getCategoryClass(comment.category)"
          >
            {{ comment.category_label }}
          </span>
          <span *ngIf="comment.context_info" class="px-2 py-1 text-xs font-medium rounded bg-blue-100 text-blue-800 flex items-center gap-1">
            <svg class="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            {{ comment.context_info.name }}
          </span>
          <span class="text-sm text-gray-600">
            por {{ comment.teacher_name }}
          </span>
        </div>
        <div class="flex items-center gap-2">
          <span class="text-xs text-gray-500">
            {{ comment.created_at | date:'dd/MM/yyyy HH:mm' }}
          </span>
          <button
            *ngIf="canEdit(comment)"
            (click)="openEditModal(comment)"
            class="text-primary hover:text-red-700 text-sm"
            title="Editar"
          >
            <i class="fas fa-edit"></i>
          </button>
          <button
            *ngIf="canEdit(comment)"
            (click)="deleteComment(comment)"
            class="text-red-600 hover:text-red-800 text-sm"
            title="Eliminar"
          >
            <i class="fas fa-trash"></i>
          </button>
        </div>
      </div>

      <!-- Comment Content -->
      <div class="text-gray-700 whitespace-pre-wrap">
        {{ comment.comment }}
      </div>

      <!-- Modified Indicator -->
      <div *ngIf="comment.created_at !== comment.updated_at" class="text-xs text-gray-400 mt-2">
        Modificado: {{ comment.updated_at | date:'dd/MM/yyyy HH:mm' }}
      </div>
    </div>
  </div>
</div>
